var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 7,
    viewBox: "0 0 54 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8333 3.5C47.8333 4.97276 49.0272 6.16667 50.5 6.16667C51.9728 6.16667 53.1667 4.97276 53.1667 3.5C53.1667 2.02724 51.9728 0.833333 50.5 0.833333C49.0272 0.833333 47.8333 2.02724 47.8333 3.5ZM0.5 4H50.5V3H0.5V4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightLine);
export default __webpack_public_path__ + "static/media/rightLine.f7aa84c30dd3e29def6f3366e9c6a863.svg";
export { ForwardRef as ReactComponent };